import { useIsApiReady } from "@/hooks/use-api-ready";
import { salthubClientControllerGetSalthubClients } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

/**
 * SaltHub clients a team group can be tagged with. Super users only.
 */
export const useSalthubClientsData = () => {
  const {
    data: clients,
    isFetching,
    error,
  } = useQuery({
    enabled: useIsApiReady(),
    initialData: [],
    queryKey: queryKeys.salthubClients(),
    queryFn: () =>
      salthubClientControllerGetSalthubClients({ throwOnError: true }).then(
        (res) => res.data.data,
      ),
    // The client list rarely changes. initialData would otherwise read as fresh.
    initialDataUpdatedAt: 0,
    staleTime: 5 * 60 * 1000,
  });

  return {
    clients,
    isLoading: isFetching,
    error,
  };
};
